import script from "./SaintsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SaintsTable.vue?vue&type=script&setup=true&lang=js"

import "./SaintsTable.vue?vue&type=style&index=0&id=6d833218&lang=css"

const __exports__ = script;

export default __exports__